var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTourcam = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C0.895431 2 0 2.89543 0 4V12C0 13.1046 0.895431 14 2 14H9C10.1046 14 11 13.1046 11 12V4C11 2.89543 10.1046 2 9 2H2ZM3 5.80902V10.191C3 10.5627 3.39116 10.8044 3.72361 10.6382L8.10557 8.44721C8.4741 8.26295 8.4741 7.73705 8.10557 7.55279L3.72361 5.3618C3.39116 5.19558 3 5.43733 3 5.80902Z",
    fill: "#005E7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.27273L14.3668 3.33629C15.0197 2.80207 16 3.26662 16 4.11024V11.8898C16 12.7334 15.0197 13.1979 14.3668 12.6637L12 10.7273V5.27273Z",
    fill: "#005E7A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTourcam);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tourcam.9f4a015d25401ad603b63ea25ec82605.svg";